import { EntityType } from "@mapmycustomers/shared/enum";
import { Activity } from "@mapmycustomers/shared/types/entity";
import {
  EntitiesSupportingRoutes,
  EntityTypesSupportingRoutes,
} from "@mapmycustomers/shared/types/entity/types";

export interface ActivityStopEntity {
  entityType: EntityTypesSupportingRoutes;
  id: EntitiesSupportingRoutes["id"];
}

/**
 * Resolve a scheduled activity to the entity its route stop represents.
 * Prefer-company by presence: the activity's account (Company) if present,
 * else its contact (Person). Returns undefined when neither is linked.
 */
const resolveActivityStopEntity = (activity: Activity): ActivityStopEntity | undefined => {
  if (activity.account) {
    return { id: activity.account.id, entityType: EntityType.COMPANY };
  }
  if (activity.contact) {
    return { id: activity.contact.id, entityType: EntityType.PERSON };
  }
  return undefined;
};

export default resolveActivityStopEntity;
